import { useUrlSyncedTableState } from '@mews/framework';
import { Table, TableActiveColumnFilters, TableProvider } from '@optimus-web/core';
import { RateGroupOverview } from '@mews-commander/data-access';
import { WithServiceId } from '@mews-commander/types';
import { useRateGroupOverviewEntries } from '../../queries';
import { useRateGroupTableColumns } from './columns';
import { RateGroupTableHeader } from './RateGroupTableHeader';

export const RateGroupTable = ({ serviceId }: WithServiceId) => {
    const columns = useRateGroupTableColumns();

    const [tableState, setTableState] = useUrlSyncedTableState<RateGroupOverview>({
        columns,
        extraQuery: {
            OwnerId: serviceId,
        },
    });

    const { data, isFetching } = useRateGroupOverviewEntries({
        serviceId,
        ...tableState,
    });

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <RateGroupTableHeader subTitle={data?.totalRowCount || '0'} />
            <TableActiveColumnFilters />
            <Table
                uniqueRowId="id"
                data={data?.data || []}
                amountOfRows={data?.totalRowCount ?? 0}
                loading={isFetching}
                fixedFirstColumn
            />
        </TableProvider>
    );
};
